
import EventEmitter from 'eventemitter2';
import Progress from '../progress/progress.js';


const defaultOptions = {
  method: 'GET',
  params: {}
};


class FileLoader extends EventEmitter {

  get data() {
    return this._data;
  }

  get contentType() {
    return this._contentType;
  }

  get isAborted() {
    return this._isAborted;
  }

  constructor(request, options = {}) {
    super();

    this.request = request;
    this.options = Object.assign({}, defaultOptions, options);

    this.xhr = new XMLHttpRequest();
    this._progress = new Progress();

    this._data = null;
    this._contentType = '';
    this._isAborted = false;

    this._handleLoadend = this._handleLoadend.bind(this);
    this._handleAbort = this._handleAbort.bind(this);
    this._handleProgress = this._handleProgress.bind(this);

    this._bindEvents();
  }

  _bindEvents() {
    this.xhr.addEventListener('abort', this._handleAbort);
    this.xhr.addEventListener('progress', this._handleProgress);
    this.xhr.addEventListener('loadend', this._handleLoadend);
  }

  _unbindEvents() {
    this.xhr.removeEventListener('abort', this._handleAbort);
    this.xhr.addEventListener('progress', this._handleProgress);
    this.xhr.removeEventListener('loadend', this._handleLoadend);
  }

  load() {

    if(this._isAborted) {
      throw new Error('the XMLHttpRequest is already aborted');
    }

    const opts = this.options;
    const params = opts.params;
    const method = opts.method.toLowerCase();


    const payload = Object.keys(params).map((prop) => {
      return `${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`;
    });

    // TODO: Queryがundefinedになるものを直す
    let [request, query] = this.request.split('?');
    this.xhr.open(opts.method, method === 'get' ? request + `?${query}&${payload}` : request);
    this.xhr.responseType = 'arraybuffer';
    this.xhr.send(method === 'post' ? payload : null);
  }

  abort() {
    if(this.xhr.readyState > 0 && this.xhr.readyState < 4) {
      this.xhr.abort();
      this._isAborted = true;
    }
  }

  _handleAbort(evt) {
    this._progress.abort();
    this.emit('abort');
  }

  _handleProgress(evt) {
    this._progress.update(evt.loaded);
  }

  _handleLoadend(evt) {

    const status = this.xhr.status;

    if(status === 200 || status === 304) {
      const contentType = this.xhr.getResponseHeader('content-type');

      const ab = this.xhr.response;
      this._data = ab;
      this._contentType = contentType;
      this._file = new Blob([ab], { type: contentType });

      this._progress.complete();
      this.emit('complete', ab);
    }
  }
}


export default FileLoader;



// WEBPACK FOOTER //
// ./src/js/app/utils/loader/FileLoader.js